module.exports = __webpack_public_path__ + "static/img/download-phone.a401bbed.png";